module.exports = __webpack_public_path__ + "static/media/Samuel Jackson Headshot_1602612099771.251fa311.png";